import { AfterViewInit, Component, inject } from '@angular/core';
import { Card } from 'primeng/card';
import { I18nService } from '../../../core/services/i18n.service';
import { BaseComponent } from '../base/base.component';

@Component({
  selector: 'app-girocode-dummy',
  imports: [
    Card
  ],
  templateUrl: './girocode-dummy.component.html',
})
export class GirocodeDummyComponent extends BaseComponent implements AfterViewInit {

  public i18n = inject(I18nService);

  constructor() {
    super();
  }

  ngAfterViewInit(): void {
    /**
     * Some controls need refresh after language-changes
     */
    this.subscriptions.add(
      this.i18n.languageChanged.subscribe({
        next: value => {
          this.refreshControls = true;
          setTimeout(() => {
            this.refreshControls = false;
          }, 10);
        }
      })
    )
    /**
     * Initialize Breadcrumb-Items
     */
    setTimeout(() => {
      this.i18n.breadcrumbMenuItems.set([
        {
          icon: 'pi pi-home',
          i18nLabelKey: 'MENUDASHBOARD',
          label: this.i18n.i18nLng()['MENUDASHBOARD'],
          routerLink: ['/dashboard'],
          routerLinkActive: false,
        },
        {
          i18nLabelKey: 'MENUGIROCODE',
          label: this.i18n.i18nLng()['MENUGIROCODE'],
          routerLinkActive: true,
        },
      ]);
    }, 50);
  }

}
